import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { categoryByKey } from "@/lib/categories";
import { Sparkles, Loader2 } from "lucide-react";

export default function ActivityCategory() {
  const { category } = useParams();
  const cfg = categoryByKey(category) || { label: "Activities", hero: "", intro: "" };
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t, tr } = useLang();

  useEffect(() => {
    setLoading(true);
    api.get(`/public/programs?category=${category}`).then((r) => setPrograms(r.data)).finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, [category]);

  return (
    <div data-testid={`public-activity-${category}`}>
      <section className="relative min-h-[45vh] flex items-end overflow-hidden">
        <img src={cfg.hero} alt={cfg.label} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(14,41,22,0.95) 0%, rgba(14,41,22,0.5) 70%)" }} />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 w-full">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#C59B27] font-mono">{t("Our Activities")}</p>
          <h1 className="font-display text-4xl lg:text-5xl font-semibold text-white mt-2">{tr(cfg, "label")}</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <p className="text-lg text-[#314337] leading-relaxed max-w-3xl">{tr(cfg, "intro")}</p>

        {loading ? (
          <div className="py-16 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#C59B27]" /></div>
        ) : programs.length === 0 ? (
          <div className="mt-10 bg-[#F2EEE5] rounded-xl p-10 text-center text-[#5C7264]">
            <Sparkles className="h-10 w-10 mx-auto mb-3 text-[#C59B27]/50" />
            Detailed programs for this activity will be published soon.
          </div>
        ) : (
          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {programs.map((p) => (
              <div key={p.id} className="bg-white rounded-xl border border-[#E2DAD0] overflow-hidden hover:-translate-y-1 hover:shadow-md transition-all" data-testid={`program-${p.id}`}>
                {p.image_path && <div className="h-44 bg-[#E8F0EA]"><img src={fileUrl(p.image_path)} alt={p.title} className="h-full w-full object-cover" /></div>}
                <div className="p-5">
                  <h3 className="font-display text-xl font-semibold text-[#194324]">{tr(p, "title")}</h3>
                  <p className="text-sm text-[#3A4E41] mt-2 leading-relaxed">{tr(p, "description")}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
